import React, { useState, useEffect, useCallback } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import ReadMapModal from "./ReadMapModal";
import Logo from "../../logo.svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { arialFont } from "../Assets/arialFont";
import { arialBoldFont } from "../Assets/arialBoldFont";
import { WidthFull } from "@mui/icons-material";
import { PageSizes } from "pdf-lib";
import logo from "../../eyesoftlogo.png";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useIntl, IntlProvider, FormattedMessage } from "react-intl";
import messages from "../../locales";
import { FLOAT } from "html2canvas/dist/types/css/property-descriptors/float";
import axios from "axios";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../Themes/themes";

//Öğrenci Bilgileri ve Tarama Bilgileri Modalı
interface StudentInfoModalProps {
  open: boolean;
  handleClose: () => void;
  ID: number;
  SchoolName: string;
  ProvinceName?: string;
  DistrictName?: string;
}
interface Session {
  ID: number;
  Class: string;
  Status: string;
  RecordDateTime: string;
  Note: string;
  DyslexiaPossibility: number;
  SessionType: number;
  /*LowReadingPossibility: number;
  TypicalPossibility: number;*/
  Q1A: number | null;
  Q2A: number | null;
  Q3A: number | null;
  Q4A: number | null;
  Q5A: number | null;
  Q6A: number | null;
  Q7A: number | null;
  Q8A: number | null;
  Q9A: number | null;
  Q10A: number | null;
}
interface student {
  ID: number;
  Name: string;
  Class: string;
  Branch: string;
  SchoolName: string;
  SessionStatus: string;
  DyslexiaPossibility: number;
  SessionType: number;
  Gender: string;
  TC: string;
  Birthdate: string;
  Note: string;
  ProvinceName: string;
  DistrictName: string;
}
const StudentInfoModal: React.FC<StudentInfoModalProps> = ({
  open,
  handleClose,
  ID,
  SchoolName,
  ProvinceName,
  DistrictName,
}) => {
  //const [language, setLanguage] = useState<"en" | "tr">("tr"); // Varsayılan dili Türkçe olarak ayarladık
  const [language, setLanguage] = useState<"en" | "tr" | "ar">(
    (localStorage.getItem("selectedLanguage") as "en" | "tr" | "ar") || "tr"
  );
  const handleChangeLanguage = (lang: "en" | "tr" | "ar") => {
    setLanguage(lang);
  };
  const intl = useIntl();
  const [questions, setQuestions] = useState<number[]>([]);
  const [readMapModalOpen, setReadMapModalOpen] = useState(false);
  const [selectedMap, setSelectedMap] = useState<string | null>(null);
  const [sessions, setSessions] = useState<Session[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filteredSessionID, setFilteredSessionID] = useState<number | null>(
    null
  );
  const [sessionNote, setSessionNote] = useState<string | null>(null);
  const [student, setStudent] = useState<student | null>(null);
  const [dyslexiaPossibility, setDyslexiaPossibility] = useState<number | null>(
    null
  );
  const [sessionType, setSessionType] = useState<number | null>(null);
  const [studentName, setStudentName] = useState<string>();
  const [recordDateTime, setRecordDateTime] = useState<string>();
  const [status, setStatus] = useState<string>();
  useEffect(() => {
    if (open) {
      const fetchSessions = async () => {
        try {
          setIsLoading(true);
          const response = await fetch(
            `https://eyelexia.eyesoft.com.tr/api/get-sessions?student_id=${ID}`
          );
          const data: Session[] = await response.json();
          if (!Array.isArray(data))
            throw new Error("Unexpected response format");
          setSessions(data.reverse());
        } catch (err) {
          setError(
            `${intl.formatMessage({
              id: "sessionerror",
            })}`
          );
        } finally {
          setIsLoading(false);
        }
      };

      fetchSessions();
    }
  }, [open]);
  const getDyslexiaLevelText = (value: number | null | undefined): string => {
    if (value == null) return "-";

    const percent = Math.round(value * 100);

    if (percent >= 0 && percent < 25)
      return intl.formatMessage({ id: "very_low" });

    if (percent >= 25 && percent < 50) return intl.formatMessage({ id: "low" });

    if (percent >= 50 && percent < 75)
      return intl.formatMessage({ id: "high" });

    if (percent >= 75) return intl.formatMessage({ id: "very_high" });

    return "-";
  };
  useEffect(() => {
    const fetchStudentsData = async () => {
      try {
        const response = await axios.get(
          `https://eyelexia.eyesoft.com.tr/api/get-child?id=${ID}`
        );
        setStudent(response.data);
        localStorage.setItem("student", JSON.stringify(response.data));
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };

    if (ID) fetchStudentsData(); // ID varsa istek gönder
  }, [ID]);

  const formatRevelantDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Gün
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ay (0'dan başlar, bu yüzden +1 ekliyoruz)
    const year = date.getFullYear(); // Yıl

    return `${day}/${month}/${year}`; // İstediğiniz format
  };
  const handlePhotoOpen = useCallback(
    (index: number) => {
      const relevantSessions = sessions.map((session) => session.ID);
      setFilteredSessionID(relevantSessions[index]);
      const relevantNote = sessions[index]?.Note || "";
      setSessionNote(relevantNote);

      const relevantDyslexia = sessions[index]?.DyslexiaPossibility || null;
      setDyslexiaPossibility(relevantDyslexia);

      const relevantSessionType = sessions[index]?.SessionType || null;
      setSessionType(relevantSessionType);

      const text1 = [
        sessions[index]?.Q1A || null,
        sessions[index]?.Q2A || null,
        sessions[index]?.Q3A || null,
        sessions[index]?.Q4A || null,
        sessions[index]?.Q5A || null,
      ].filter((item) => item !== null) as number[];
      const text2 = [
        sessions[index]?.Q6A || null,
        sessions[index]?.Q7A || null,
        sessions[index]?.Q8A || null,
        sessions[index]?.Q9A || null,
        sessions[index]?.Q10A || null,
      ].filter((item) => item !== null) as number[];
      setQuestions([...text1, ...text2]);

      setStudentName(student?.Name);
      //setStatus(student?.SessionStatus);
      setStatus(sessions[index]?.Status);

      const relevantDate = formatRevelantDate(
        sessions[index]?.RecordDateTime || ""
      );
      //const relevantDate = sessions[index + 1]?.RecordDateTime || ""; // index + 1 ile 2. öğeyi alıyoruz
      setRecordDateTime(relevantDate);
      setReadMapModalOpen(true);
    },
    [sessions]
  );
  const handlePhotoClose = () => {
    setReadMapModalOpen(false);
    setFilteredSessionID(null);
  };
  const pngtoBase64ViaFetch = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  const downloadPDF = async () => {
    const doc = new jsPDF();

    // Fontu ekle
    doc.addFileToVFS("arial.ttf", arialFont);
    doc.addFileToVFS("arial_bold.ttf", arialBoldFont);
    doc.addFont("arial.ttf", "arial", "normal");
    doc.addFont("arial_bold.ttf", "arialbold", "bold");
    doc.setFont("arial", "normal");

    let logoData: string; // logoData değişkeninin türü string olarak belirlendi
    try {
      logoData = await pngtoBase64ViaFetch(logo);
    } catch (error) {
      return; // Logo yüklenmezse fonksiyondan çık
    }

    // Sayfa genişliği ve yüksekliği
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const logoWidth = 20; // Logonun genişliği
    const logoHeight = 5; // Logonun yüksekliği

    // İlk sayfada içeriği ekle
    doc.setFontSize(22);
    const textWidth = doc.getTextWidth(SchoolName);
    const xPosition = (pageWidth - textWidth) / 2;

    // Logo sağ üst köşede
    doc.addImage(
      logoData,
      "PNG",
      pageWidth - logoWidth - 10,
      10,
      logoWidth,
      logoHeight
    ); // Sağ üst köşe

    // PDF içeriği
    doc.text(
      `${intl.formatMessage({
        id: "meb",
      })}`,
      xPosition,
      10
    );
    doc.setFontSize(14);
    doc.setFont("arialbold", "bold");
    doc.text(
      `${intl.formatMessage({
        id: "studentinformation",
      })}`,
      20,
      20
    );
    doc.setFont("arial", "normal");

    // Öğrenci Bilgileri
    const studentData = [
      {
        label: `${intl.formatMessage({ id: "name" })}`,
        value: student?.Name,
      },
      { label: `${intl.formatMessage({ id: "tc" })}`, value: student?.TC },
      {
        label: `${intl.formatMessage({ id: "gender" })}`,
        value: student?.Gender === "1" ? "Kız" : "Erkek",
      },
      {
        label: `${intl.formatMessage({ id: "birthday" })}`,
        value: student?.Birthdate,
      },
      {
        label: `${intl.formatMessage({ id: "dyslexia%" })}`,
        value:
          sessions[0]?.SessionType === 2 ||
          sessions[0]?.SessionType === 3 ||
          sessions[0]?.DyslexiaPossibility == null ||
          sessions[0]?.DyslexiaPossibility == undefined ||
          isNaN(sessions[0]?.DyslexiaPossibility) ||
          sessions[0]?.DyslexiaPossibility === 0
            ? "-"
            : getDyslexiaLevelText(sessions[0]?.DyslexiaPossibility),
      },
      {
        label: `${intl.formatMessage({ id: "province" })}`,
        value: ProvinceName,
      },
      {
        label: `${intl.formatMessage({ id: "district" })}`,
        value: DistrictName,
      },
      {
        label: `${intl.formatMessage({ id: "schoolname" })}`,
        value: SchoolName,
      },
      {
        label: `${intl.formatMessage({ id: "class" })}`,
        value: student?.Class,
      },
      {
        label: `${intl.formatMessage({ id: "branch" })}`,
        value: student?.Branch,
      },
    ];

    // Tablo başlıkları
    const cellPadding = 5;
    const rowHeight = 7; // Satır yüksekliği
    const columnWidths = [50, 100]; // Label ve value sütunlarının genişliği
    let yPosition = 25;

    // Tabloyu çiz
    studentData.forEach((data, index) => {
      const labelWidth = columnWidths[0];
      const valueWidth = columnWidths[1];

      // Etiket hücresini çiz
      doc.text(data.label, 20, yPosition + 5); // Etiket metnini çiz (5 px padding)

      // Değer hücresini çiz
      doc.text(String(data.value || ""), 20 + labelWidth, yPosition + 5); // Değer metnini çiz

      // Yükseklik ayarla
      yPosition += rowHeight;

      // Sayfa sonuna gelinirse yeni sayfa ekle
      if (yPosition > pageHeight - 40) {
        doc.addPage();
        yPosition = 30;

        // Yeni sayfada logo ve başlık ekle
        doc.addImage(
          logoData,
          "PNG",
          (pageWidth - logoWidth) / 2,
          10,
          logoWidth,
          logoHeight
        );
        doc.text("Öğrenci Bilgileri", 20, 140);
      }
    });

    doc.setFontSize(14);
    doc.setFont("arialbold", "bold");
    doc.text(
      `${intl.formatMessage({
        id: "readdatas",
      })}`,
      20,
      120
    );

    // Okuma Seansları Tablosu
    const headers = [
      { text: `${intl.formatMessage({ id: "dateformat" })}`, width: 110 },
      { text: `${intl.formatMessage({ id: "class" })}`, width: 40 },
      /*{ text: `${intl.formatMessage({ id: "typical%" })}`, width: 50 },
      { text: `${intl.formatMessage({ id: "lowreading%" })}`, width: 100 },*/
      { text: `${intl.formatMessage({ id: "dyslexia%" })}`, width: 60 },
    ];

    // Hücre toplam genişliğini hesapla
    const totalWidth = headers.reduce((acc, header) => acc + header.width, 0);

    // Her hücrenin yeni genişliğini sayfaya uyacak şekilde küçült
    const scaleFactor = (pageWidth - 20) / totalWidth; // 40: sol ve sağ boşluk için
    const newHeaders = headers.map((header) => ({
      text: header.text,
      width: header.width * scaleFactor, // Hücre genişliklerini küçültüyoruz
    }));

    // Satır yüksekliğini de orantılı olarak küçült
    const lineHeight = 10 * scaleFactor; // lineHeight'i küçültüyoruz

    doc.setFontSize(14);
    yPosition = 130;

    // Başlık satırını yaz ve çerçeve çiz
    let xPosition2 = 10; // Başlıklar sayfaya ortalanmış şekilde başlar
    newHeaders.forEach((header) => {
      // Başlık hücresini çiz ve metni ekle
      doc.text(header.text, xPosition2 + 5, yPosition + 7); // 5 px sağa ve aşağıya kaydırarak metni hizalayalım
      doc.rect(xPosition2, yPosition, header.width, lineHeight + 5); // Başlık hücrelerinin etrafını çerçevele
      xPosition2 += header.width; // xPosition değeri her döngüde arttırılır
    });
    yPosition += lineHeight + 5; // Satır aralığına biraz ekleyerek başlık ile veri arasına boşluk bırakıyoruz

    doc.setFont("arial", "normal");
    // Seansları döngü ile ekleme
    sessions.forEach((session, index) => {
      const row = [
        { text: new Date(session.RecordDateTime).toLocaleString(), width: 110 },
        { text: `${session.Class || student?.Class}`, width: 40 },
        /*{ text: `${getStatusText(session.TypicalPossibility)}`, width: 50 },
        { text: `${getStatusText(session.LowReadingPossibility)}`, width: 100 },*/
        {
          text:
            session.SessionType === 2 || session.SessionType === 3
              ? "-"
              : getDyslexiaLevelText(session.DyslexiaPossibility),
          width: 60,
        },
      ];

      // Satırdaki her hücrenin genişliğini orantılı olarak küçült
      const newRow = row.map((cell) => ({
        text: cell.text,
        width: cell.width * scaleFactor, // Hücre genişliklerini küçültüyoruz
      }));

      xPosition2 = 10; // Her satır için xPosition sıfırlanır
      newRow.forEach((cell) => {
        // Veri hücresini çiz ve metni ekle
        doc.text(cell.text, xPosition2 + 5, yPosition + 7); // 5 px sağa ve aşağıya kaydırarak metni hizalayalım
        doc.rect(xPosition2, yPosition, cell.width, lineHeight + 5); // Veri hücrelerinin etrafını çerçevele
        xPosition2 += cell.width; // xPosition değeri her hücrede arttırılır
      });

      yPosition += lineHeight + 5; // Satır aralığına biraz ekleyerek bir sonraki satıra geçiyoruz

      // Sayfa sonuna gelinirse yeni sayfa ekle
      if (yPosition > pageHeight - 20) {
        doc.addPage();
        yPosition = 30;

        // Yeni sayfada logo ve başlık ekle
        doc.addImage(
          logoData,
          "PNG",
          (pageWidth - logoWidth) / 2,
          10,
          logoWidth,
          logoHeight
        );
        doc.text(
          `${intl.formatMessage({
            id: "sessioncontinue",
          })}`,
          20,
          50
        );
        yPosition = 60;
      }
    });
    // PDF'yi indir
    doc.save(`${student?.Name} - ${student?.ID}.pdf`);
  };
  const getStatusText = (status: number) => {
    return Math.round(status * 100);
  };
  const formatDate = (dateStr: string) => {
    const [day, month, year] = dateStr.split("-");
    return `${day}.${month}.${year}`;
  };
  const getSessionNumber = (index: number) => {
    return Math.floor(index) + 1;
  };
  const formattedAnswers = questions.reduce((acc, question, index) => {
    acc[index] = [question.toString()]; // Sayıları string'e dönüştürüp bir dizi içine alıyoruz
    return acc;
  }, {} as { [key: number]: string[] });
  return (
    <>
      <IntlProvider
        locale={language}
        messages={messages[language] as unknown as Record<string, string>}
      >
        <ThemeProvider theme={theme}>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="student-modal-title"
            aria-describedby="student-modal-description"
          >
            <Box
              id="modal-content"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                height: "90%",
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
              {/* Main content area */}
              <Box
                sx={{
                  width: "100%",
                  height: "90%",
                  display: "flex",
                  flexDirection: "row",
                  flexGrow: 1,
                }}
              >
                {/* Left side */}
                <Box
                  sx={{
                    width: "50%",
                    height: "100%",
                    flex: 1,
                    borderRight: "1px solid #ddd",
                    px: 3,
                    mx: 3,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    id="student-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{
                      fontSize: {
                        xs: "0.8rem", // Daha küçük ekranlar için
                        sm: "1rem",
                        md: "1.2rem",
                        lg: "1.8rem", // Daha büyük ekranlar için
                      },
                      mt: 1,
                      mb: 3,
                    }}
                  >
                    <strong>
                      {intl.formatMessage({
                        id: "studentinformation",
                      })}
                    </strong>
                  </Typography>

                  {/* Öğrenci bilgileri */}
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%", // Otomatik yüksekliğe izin ver
                      flex: 1,
                      border: "2px solid #ccc",
                      borderRadius: "8px",
                      px: 3, // İç padding
                      py: 2, // Dikey padding
                      overflowY: "auto",
                    }}
                  >
                    <Table
                      sx={{
                        "& td, & th": {
                          fontSize: {
                            xs: "0.2rem", // Küçük ekranlarda yazı boyutunu büyüt
                            sm: "0.5rem", // Orta ekranlarda
                            md: "1.0rem", // Orta boyutlu ekranlarda
                            lg: "1.4rem", // Büyük ekranlarda
                          },
                          padding: "6px", // Hücre içindeki boşluğu azalt
                        },
                      }}
                    >
                      <TableBody>
                        {[
                          { label: "name", value: student?.Name },
                          { label: "tc", value: student?.TC },
                          {
                            label: "gender",
                            value: student?.Gender === "1" ? "Kız" : "Erkek",
                          },
                          {
                            label: "birthday",
                            value: student?.Birthdate,
                          },
                          {
                            label: "currentdiagnosisstatus",
                            value: (
                              <>
                                {sessions[0]?.SessionType === 2 ||
                                sessions[0]?.SessionType === 3 ||
                                sessions[0]?.DyslexiaPossibility == null ||
                                sessions[0]?.DyslexiaPossibility == undefined ||
                                isNaN(sessions[0]?.DyslexiaPossibility) ||
                                sessions[0]?.DyslexiaPossibility === 0
                                  ? "-"
                                  : getDyslexiaLevelText(
                                      sessions[0]?.DyslexiaPossibility
                                    )}
                              </>
                            ),
                          },
                          { label: "province", value: ProvinceName },
                          { label: "district", value: DistrictName },
                          { label: "schoolname", value: SchoolName },
                          { label: "class", value: student?.Class },
                          { label: "branch", value: student?.Branch },
                        ].map((item, index) => (
                          <TableRow
                            key={item.label}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                            }}
                          >
                            <TableCell>
                              <strong>
                                {intl.formatMessage({ id: item.label })}
                              </strong>
                            </TableCell>
                            <TableCell>{item.value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Box>

                {/* Right side */}

                <Box
                  sx={{
                    width: "50%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  {/* Upper right part */}
                  <Typography
                    variant="body1"
                    sx={{
                      width: "95%",
                      height: "10%",
                      fontSize: {
                        xs: "0.3rem",
                        sm: "0.8rem",
                        md: "1.2rem",
                        lg: "1.8rem",
                      },
                      mt: 1,
                    }}
                  >
                    <strong>
                      {intl.formatMessage({
                        id: "readdatas",
                      })}
                    </strong>
                  </Typography>
                  <Box
                    sx={{
                      width: "95%",
                      height: "90%",
                      paddingBottom: "%2",
                      marginBottom: "%2",
                      marginLeft: "%1",
                      marginRight: "%1",
                      bgcolor: "white",
                      overflowY: "auto",
                    }}
                  >
                    {isLoading && (
                      <Typography>
                        {intl.formatMessage({
                          id: "loading",
                        })}
                      </Typography>
                    )}
                    {error && <Typography>{error}</Typography>}
                    {sessions.length >= 1 ? (
                      <TableContainer>
                        <Table
                          size="small"
                          stickyHeader
                          sx={{
                            height: "100%",
                            width: "100%",
                            borderCollapse: "separate",
                            borderSpacing: "0 10px", // 10px boşluk bırak
                            fontSize: {
                              xs: "0.3rem",
                              sm: "0.5rem",
                              md: "1.0rem",
                              lg: "1.4rem",
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontSize: {
                                    xs: "0.3rem",
                                    sm: "0.5rem",
                                    md: "1.0rem",
                                    lg: "1.4rem",
                                  },
                                }}
                              >
                                <strong>
                                  {intl.formatMessage({
                                    id: "date",
                                  })}
                                </strong>
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontSize: {
                                    xs: "0.3rem",
                                    sm: "0.5rem",
                                    md: "1.0rem",
                                    lg: "1.4rem",
                                  },
                                }}
                              >
                                <strong>
                                  {intl.formatMessage({
                                    id: "class",
                                  })}
                                </strong>
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontSize: {
                                    xs: "0.3rem",
                                    sm: "0.5rem",
                                    md: "1.0rem",
                                    lg: "1.4rem",
                                  },
                                }}
                              >
                                <strong>
                                  {intl.formatMessage({
                                    id: "dyslexia%",
                                  })}
                                </strong>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  fontSize: {
                                    xs: "0.3rem",
                                    sm: "0.5rem",
                                    md: "1.0rem",
                                    lg: "1.4rem",
                                  },
                                }}
                              >
                                <strong>
                                  {intl.formatMessage({
                                    id: "detail",
                                  })}
                                </strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sessions.map((session, index) =>
                              index < sessions.length ? (
                                <TableRow
                                  key={index}
                                  sx={{
                                    backgroundColor:
                                      session.SessionType === 2 ||
                                      session.SessionType === 3
                                        ? "transparent"
                                        : session.DyslexiaPossibility * 100 >=
                                          50
                                        ? "#F2C3B9"
                                        : "#D6E5BD",
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      fontSize: {
                                        xs: "0.3rem",
                                        sm: "0.5rem",
                                        md: "1.0rem",
                                        lg: "1.4rem",
                                      },
                                    }}
                                  >
                                    {new Date(
                                      sessions[index].RecordDateTime
                                    ).toLocaleString()}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: {
                                        xs: "0.3rem",
                                        sm: "0.5rem",
                                        md: "1.0rem",
                                        lg: "1.4rem",
                                      },
                                    }}
                                  >
                                    {sessions[index].Class || student?.Class}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: {
                                        xs: "0.3rem",
                                        sm: "0.5rem",
                                        md: "1.0rem",
                                        lg: "1.4rem",
                                      },
                                    }}
                                  >
                                    {sessions[index].SessionType === 2 ||
                                    sessions[index].SessionType === 3
                                      ? "-"
                                      : getDyslexiaLevelText(
                                          sessions[index].DyslexiaPossibility
                                        )}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      fontSize: {
                                        xs: "0.3rem",
                                        sm: "0.5rem",
                                        md: "1.0rem",
                                        lg: "1.4rem",
                                      },
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        fontSize: {
                                          xs: "0.2rem", // Daha küçük yazı boyutu
                                          sm: "0.4rem",
                                          md: "0.6rem",
                                          lg: "0.9rem",
                                        },
                                        padding: {
                                          xs: "1px 2px", // Küçük padding değerleri
                                          sm: "2px 4px",
                                          md: "3px 6px",
                                          lg: "4px 8px",
                                        },
                                        minWidth: 0,
                                        minHeight: 0,
                                      }}
                                      onClick={() => handlePhotoOpen(index)}
                                    >
                                      {intl.formatMessage({
                                        id: "detail",
                                      })}
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ) : null
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Typography>
                        {intl.formatMessage({
                          id: "error",
                        })}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>

              {/* Buttons */}
              <Box
                sx={{
                  width: "99%",
                  height: "5%",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "1%",
                }}
              >
                <Button
                  onClick={downloadPDF}
                  sx={{
                    width: "20%",
                    height: "100%",
                    fontSize: {
                      xs: "0.3rem",
                      sm: "0.5rem",
                      md: "0.8rem",
                      lg: "1.0rem",
                    },
                    padding: {
                      xs: "2px 4px", // Küçük ekranlar için padding
                      sm: "4px 8px", // Orta ekranlar
                      md: "6px 12px", // Büyük ekranlar için padding
                      lg: "8px 16px",
                    },
                  }}
                  variant="contained"
                >
                  {intl.formatMessage({
                    id: "informationdownload",
                  })}
                </Button>
              </Box>
            </Box>
          </Modal>
        </ThemeProvider>
      </IntlProvider>
      <ReadMapModal
        open={readMapModalOpen}
        onClose={handlePhotoClose}
        sessionID={filteredSessionID || 0}
        sessionNote={sessionNote || ""}
        studentName={student?.Name || ""}
        recordDateTime={recordDateTime || ""}
        status={status || ""}
        schoolName={SchoolName || ""}
        provinceName={ProvinceName || ""}
        distirctName={DistrictName || ""}
        dyslexiaPossibility={dyslexiaPossibility || 0}
        sessionType={sessionType || 0}
        answers={formattedAnswers || {}}
      />
    </>
  );
};

export default StudentInfoModal;
